// ── AG Grid shared utilities ────────────────────────────────────────────────

import type { SelectionColumnDef, ValueFormatterParams } from 'ag-grid-community';

/**
 * Shared def for the AG Grid-injected selection (checkbox) column.
 * `pinned` + `lockPosition` keep it the FIRST column even when an identifier
 * column is also pinned left — per UI_STANDARDS §24 "Bulk select checkbox is
 * first column, fixed" (the injected column is otherwise unpinned and renders
 * AFTER any pinned identifier column). Pass as `selectionColumnDef` on every
 * multiRow grid.
 */
export const SELECTION_COLUMN_DEF: SelectionColumnDef = {
  width: 40,
  pinned: 'left',
  lockPosition: 'left',
  suppressMovable: true,
  resizable: false,
};

/** Em dash character — U+2014, per DATA_STANDARDS.md */
const EMPTY_CELL = '\u2014';

/**
 * Standard valueFormatter for any column that may be empty.
 * Returns em dash for null/undefined/empty, otherwise the raw value.
 * Use as defaultColDef.valueFormatter to catch all unformatted columns.
 */
export function emptyFormatter(params: ValueFormatterParams): string {
  const v = params.value;
  if (v === null || v === undefined || v === '') return EMPTY_CELL;
  return String(v);
}
